<template>
  <div>
    <LoadingContainer v-if="isLoading"/> 

    <div v-else-if="!isPrivate">
      <UserProfileIntroducingCard :user="user"/>

      <div class="container pb-5 pt-4">
        <div class="row">
          <div class="col-lg-6 col-border ">
            <UserProfileCertificatesSection :user="user" class="mb-5"/>

            <UserProfileCoursesSection :user="user" class="pt-5"/>
          </div>

          <div class="col-lg-2"></div>

          <div class="col-lg-4 mt-5 mt-lg-0">
            <UserProfileActivitiesSection :user="user"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserProfile } from '@/api/user.api'
import UserProfileIntroducingCard from '@/components/user/profile/UserProfileIntroducingCard'
import UserProfileCertificatesSection from '@/components/user/profile/UserProfileCertificatesSection'
import UserProfileCoursesSection from '@/components/user/profile/UserProfileCoursesSection'
import UserProfileActivitiesSection from '@/components/user/profile/UserProfileActivitiesSection'
import LoadingContainer from '@/components/layout/LoadingContainer'

export default {
  components: {
    UserProfileIntroducingCard,
    UserProfileCertificatesSection,
    UserProfileCoursesSection,
    UserProfileActivitiesSection,
    LoadingContainer,
  },

  data: () => ({
    user: {},
    isLoading: true,
    isPrivate: false,
  }),

  metaInfo () {
    return {
      title: this.user.id ? `Perfil ${this.user.name} | CyberClass` : null
    }
  },

  async mounted () {
    this.isLoading = true

    try {
      await this.fetchUser()
    } catch (err) {
      if (err.status === 404) {
        this.$router.replace({ name: 'home' })
      } else if (err.status === 403) {
        this.$router.replace({ name: 'home' })
      }
    }

    this.isLoading = false
  },

  computed: {
    slug () {
      return this.$route.params.slug
    }
  },

  methods: {
    async fetchUser () {
      const response = await getUserProfile(this.slug)
      this.user = response.data
    }
  }
}
</script>

<style lang="scss" scoped>
  .user-profile-courses-section {
    max-width: 662px;
  }
</style>
